import { createSlice } from '@reduxjs/toolkit'

export const CampaignTagFilterSlice = createSlice({
  name: 'campaign_tag_filter',
  initialState: {
    value: [],
  },
  reducers: {
    updateCampaignTag: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { updateCampaignTag } = CampaignTagFilterSlice.actions

export default CampaignTagFilterSlice.reducer